import { createListButtonStyles } from "@insite/content-library/Widgets/MyLists/MyListsCreateListButton";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

export const secondaryButton = Object.assign(createListButtonStyles, {
    createListButton: {
        // variant: "primary",
        // typographyProps: {
        //     size: TYPOGRAPHY.size.smaller,
        //     weight: TYPOGRAPHY.weight.bold,
        // },
        // css: css`
        //     text-transform: uppercase;
        //     border-radius: 22px;
        //     background-image: linear-gradient(to right, #44a8f7, ${COLORS.link.base});
        //     border: none;
        //     min-width: 120px;
        // `,
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
        },
        css: css`
            margin-right: 10px;
            text-transform: uppercase;
            border-radius: 22px;
            border: 1px solid ${COLORS.secondaryBtn};
            min-width: 120px;
            background: ${COLORS.white};
            color: ${COLORS.secondaryBtn};
            & :hover {
                background: ${COLORS.secondaryBg};
                border: 1px solid ${COLORS.secondaryBtn};
            }
            &:disabled:hover {
                background: ${COLORS.disabled.base};
                border: 1px solid ${COLORS.disabled.base};
            }
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            button[data-test-selector^="popoverOverflowTrigger"] {
                min-width: auto;
                width: auto;
                padding: 0;
            }
        `,
    },
});
